import { AxiosRequestConfig } from 'axios'

export interface AgeAnalysisByLevelDetailedParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface AgeData {
  level: number
  code: string
  name: string
  value: number
}

export const getAgeAnalysisByLevelDetailed = (
  params: AgeAnalysisByLevelDetailedParams,
): AxiosRequestConfig => ({
  url: '/dashboard/age-analysis-by-level-detailed',
  method: 'GET',
  params,
})
